import React, { useMemo } from "react";

import { faLock } from "@fortawesome/pro-solid-svg-icons/faLock";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useIntl } from "react-intl";

import { EntityTypesSupportedByMapsPage } from "@mapmycustomers/shared/types/entity";
import { InlineSelectField, InlineSelectFieldProps } from "@mapmycustomers/ui";

import { MAP_ENTITY_TYPES } from "@app/util/map/consts";
import { getEntityTypeDisplayName } from "@app/util/ui";

interface Props extends Omit<InlineSelectFieldProps<EntityTypesSupportedByMapsPage>, "options"> {}

const EntityTypeSelectField: React.FC<Props> = (props) => {
  const intl = useIntl();

  const options = useMemo(
    () =>
      MAP_ENTITY_TYPES.map((entityType) => ({
        label: getEntityTypeDisplayName(intl, entityType, { lowercase: false, plural: true }),
        value: entityType,
      })),
    [intl]
  );

  return (
    <InlineSelectField<EntityTypesSupportedByMapsPage>
      {...props}
      options={options}
      showFooterButtons={false}
      suffixIcon={props.disabled ? <FontAwesomeIcon icon={faLock} /> : undefined}
    />
  );
};

export default EntityTypeSelectField;
